<script lang="ts">
	import Icon from '../../components/icon/Icon.svelte'
	import { getPricingContext } from './pricingContext'
	import { isUsd } from './pricingCurrency'
	import { MembershipsV1Currency } from '@sdk/Api'
	import { ChevronDown } from '@steeze-ui/heroicons'
	import { run } from 'svelte/legacy'

	const { lockedCurrency } = getPricingContext()

	let isCurrencyLocked = $derived(
		lockedCurrency && lockedCurrency !== MembershipsV1Currency.CURRENCY_UNSPECIFIED,
	)

	run(() => {
		if (isCurrencyLocked) {
			isUsd.set(lockedCurrency === MembershipsV1Currency.CURRENCY_USD)
		}
	})
</script>

{#if !isCurrencyLocked}
	<div class="relative right-0 flex h-full items-center justify-end">
		<Icon class="pointer-events-none absolute" src={ChevronDown} />
		<select
			class="appearance-none bg-transparent pr-5 text-lg focus:outline-hidden"
			bind:value={$isUsd}
		>
			<option value={true}>USD</option>
			<option value={false}>EUR</option>
		</select>
	</div>
{/if}
